import React from 'react';

// Components
import Folder from '../folder/folder.jsx';
import Loader from '../loader.jsx';

// Helpers
import encyclopediaApi from 'api/encyclopedia';

class FileBrowser extends React.Component {
    state = {
        folders: null
    }
    maxCacheAge = 15 * 60 * 1000;
    folderBlocklist = [
        "c6a0b12c-0139-48a5-9774-5012b6ffaefe"
    ];

    setFolderFiles(folder, files) {
        folder.files = files.filter(file => file.parent === folder.id);

        folder.children.forEach(childFolder => {
            this.setFolderFiles(childFolder, files);
        });
    }

    filterBlockedFolders(folders) {
        folders = folders.filter(f => !this.folderBlocklist.includes(f.id));
        folders.forEach(f => f.children = this.filterBlockedFolders(f.children));
        return folders;
    }

    componentDidMount() {
        let folderCache = localStorage.getItem('folders');
        if (folderCache) {
            folderCache = JSON.parse(folderCache);
            
            if (Date.now() - folderCache.cachedAt > this.maxCacheAge) {
                folderCache = null;
            }
        }

        if (folderCache) {
            this.setState({
                folders: folderCache.folders
            });
        } else {
            encyclopediaApi.getFolders().then(folders => {
                folders = this.filterBlockedFolders(folders);
                folders.forEach(folder => {
                    encyclopediaApi.getFolderContents(folder.path + folder.id + ",").then(files => {
                        files.forEach(file => {
                            let ancestors = file.path
                                .substring(1, file.path.length - 1)     // Remove leading and trailing comma
                                .split(',');                            // Split into array of folder ids
                            file.parent = ancestors[ancestors.length - 1];
                        });
    
                        this.setFolderFiles(folder, files);
    
                        localStorage.setItem('folders', JSON.stringify({
                            folders: folders,
                            cachedAt: Date.now()
                        }));
                        this.setState({
                            folders: folders
                        });
                    }).catch(err => {
                        folder.fileError = "An error occurred while fetching the files for this folder."
                    });
                });
            }).catch(err => {
                console.log("Error fetching folders");
                console.log(err);
            });
        }
    }

    render() {
        let foldersJSX;
        if (this.state.folders) {
            foldersJSX = this.state.folders.map(folder => <Folder key={folder.id} folder={folder} open={false} silent={true} />);
        }

        return (
            <div className="file-browser">
                <h3 className="title">Browse Files</h3>
                <Loader loaded={this.state.folders !== null}>
                    <ul>
                        {foldersJSX}
                    </ul>
                </Loader>
            </div>
        );
    }
}

export default FileBrowser;
